'use client'

import { usePathname } from 'next/navigation'

import { BookingProgressBar } from '@/src/components/layout/BookingProgressBar'
import { WizardLayout } from '@/src/components/wizard/WizardLayout'
import { bookingStudentFlow } from '@/src/config/flows/booking-student.flow'
import { getGroupForStep, getMainStepCount } from '@/src/lib/flow-engine/types'
import { useStudentBookingStore } from '@/src/lib/store/studentBookingStore'

export default function BookingStudentLayout({ children }: { children: React.ReactNode }) {
  const { currentStep } = useStudentBookingStore()
  const pathname = usePathname()
  const safePathname = pathname ?? ''
  const isSuccessPage = safePathname.endsWith('/success') || safePathname.endsWith('/success/')

  return (
    <WizardLayout
      progressBar={
        isSuccessPage ? undefined : (
          <BookingProgressBar
            currentStep={getGroupForStep(bookingStudentFlow, currentStep)}
            totalSteps={getMainStepCount(bookingStudentFlow)}
          />
        )
      }
    >
      {children}
    </WizardLayout>
  )
}
